import { c as _c } from "react/compiler-runtime";
import React, { type SVGProps } from 'react';
type Props = SVGProps<SVGSVGElement> & {
  backgroundColor: string;
  borderColor: string;
};
export const Star = React.forwardRef<SVGSVGElement, Props>((t0, ref) => {
  const $ = _c(11);
  let backgroundColor;
  let borderColor;
  let props;
  if ($[0] !== t0) {
    ({
      backgroundColor,
      borderColor,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = backgroundColor;
    $[2] = borderColor;
    $[3] = props;
  } else {
    backgroundColor = $[1];
    borderColor = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== backgroundColor || $[5] !== borderColor) {
    t1 = <path d="M11.5811 6.06055C11.7783 5.75782 12.2217 5.75782 12.4189 6.06055L14.1182 8.67188C14.3198 8.98178 14.6293 9.20671 14.9863 9.30273L17.9941 10.1113C18.3433 10.2052 18.4812 10.628 18.2539 10.9092L16.2949 13.332C16.0627 13.6195 15.9449 13.9825 15.9639 14.3516L16.124 17.4629C16.1426 17.8238 15.7838 18.0849 15.4463 17.9561L12.5361 16.8418C12.1909 16.7097 11.8091 16.7097 11.4639 16.8418L8.55371 17.9561C8.21618 18.0849 7.85739 17.8238 7.87598 17.4629L8.03613 14.3516C8.05509 13.9825 7.9373 13.6195 7.70508 13.332L5.74609 10.9092C5.5188 10.628 5.65669 10.2052 6.00586 10.1113L9.01367 9.30273C9.37072 9.20671 9.68018 8.98178 9.88184 8.67188L11.5811 6.06055Z" fill={backgroundColor} stroke={borderColor} />;
    $[4] = backgroundColor;
    $[5] = borderColor;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props || $[8] !== ref || $[9] !== t1) {
    t2 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t1}</svg>;
    $[7] = props;
    $[8] = ref;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
});